export const PAGE_HEADING = "Notification settings";
export const PORTAL_SETTINGS_HEADING = "Portal Notification";
export const EMAIL_SETTINGS_HEADING = "Notification summary emails";
export const PORTAL_SETTINGS_INTRO =
	"Select which notifications you would like to recieve";
export const EMAIL_NOTIFICATION_INTRO =
	"How often you would like to to recieve new notification summaries via email? ";
export const EMAIL_NOTIFICATION_DISABLED =
	"Notifications disabled. Enable from within Portal notifications settings ";
export const EDIT_LABEL = "EDIT";
export const EMAIL_WEEKLY_HEADING = "Receive mail every";
export const NO_CONTENT_AVAILABLE_HEADING = "Everything’s looking good!";
export const NO_CONTENT_AVAILABLE_DESCRIPTION = "You have no new notifications";

export const CONFIRM_DELETE = "Yes, delete";
export const DELETE_NOTIFICATION = "Delete notification ?";



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/content.js